/**
 * [비밀번호 강도 계산기] - 회원가입, 비밀번호 변경 폼에서 공유
 *
 * 길이(8자 이상), 대문자, 숫자, 특수문자 4가지 기준으로 점수를 매긴다.
 * SignupForm, ForgotPasswordForm, PasswordStrength 컴포넌트에서 사용.
 */

export type StrengthLevel = 'weak' | 'medium' | 'strong' | 'very-strong';

export interface StrengthResult {
  score: number;
  level: StrengthLevel;
  label: string;
}

export function calculatePasswordStrength(password: string): StrengthResult {
  if (!password) {
    return { score: 0, level: 'weak', label: '' };
  }

  let score = 0;
  if (password.length >= 8) score++;
  if (/[A-Z]/.test(password)) score++;
  if (/[0-9]/.test(password)) score++;
  if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]/.test(password)) score++;

  let level: StrengthLevel;
  let label: string;

  switch (score) {
    case 0:
    case 1:
      level = 'weak';
      label = '약함';
      break;
    case 2:
      level = 'medium';
      label = '보통';
      break;
    case 3:
      level = 'strong';
      label = '강함';
      break;
    default:
      level = 'very-strong';
      label = '매우 강함';
      break;
  }

  return { score, level, label };
}
